export default __webpack_public_path__ + "static/media/confetti.62d8c9b7.gif";